module.exports = __webpack_public_path__ + "static/media/search-icon-white.a101f1df.svg";